import { writable } from 'svelte/store';

window.animationMenuStore = {};

export const favouriteAnimations = writable(["animations.list.handsUp", "animations.list.handsUp1"]);
window.animationMenuStore.setFavourites = (favourites) => favouriteAnimations.set(favourites);

export const purchasedAnimations = writable([]);
window.animationMenuStore.setPurchasedAnimations = (list) => purchasedAnimations.set(list);

// Биндер анимаций на клавиши (Numpad 1-5): слоты + ключ перетаскиваемой анимации
const EMPTY_SLOTS = [null, null, null, null, null];
export const bindSlots = writable([...EMPTY_SLOTS]);
window.animationMenuStore.setBindSlots = (slots) => bindSlots.set(Array.isArray(slots) ? slots : [...EMPTY_SLOTS]);

export const draggingAnim = writable(null);